import api from './Api';

export interface ConciliadoFolhaItem {
    rubricaId: number;
    codigoRubrica: string;
    descricaoRubrica: string | null;
    categoria: string | null;
    valorRubrica: number;
    tipoVinculo: 'RAZAO' | 'BANCO' | string;
    dataVinculado: string | null;
    historicoVinculado: string | null;
    valorVinculado: number | null;
}

export interface ConciliadosFolhaResponse {
    items: ConciliadoFolhaItem[];
    total: number;
    page: number;
    perPage: number;
}

export interface SugestaoFolhaItem {
    rubricaId: number;
    codigoRubrica: string;
    descricaoRubrica: string | null;
    categoria: string | null;
    valorRubrica: number;
    chaveVinculoMatch: string;
    justificativaMatch: string | null;
}

const FolhaPagamentoService = {
    iniciarProcessamento: async (esteiraId: number, cartaoId: number): Promise<void> => {
        await api.post('FolhaPagamento/iniciar', { esteiraId, cartaoId });
    },

    getConciliados: async (
        cartaoId: number,
        page: number = 1,
        perPage: number = 20,
        filtro?: string
    ): Promise<ConciliadosFolhaResponse> => {
        const params = new URLSearchParams({ cartaoId: String(cartaoId), page: String(page), perPage: String(perPage) });
        if (filtro) params.append('filtro', filtro);
        const resp = await api.get(`FolhaPagamento/conciliados?${params.toString()}`);
        return resp.data;
    },

    getSugestoesPendentes: async (cartaoId: number): Promise<SugestaoFolhaItem[]> => {
        const resp = await api.get(`FolhaPagamento/sugestoes?cartaoId=${cartaoId}`);
        return resp.data;
    },

    aceitarTodasSugestoes: async (cartaoId: number): Promise<void> => {
        await api.patch(`FolhaPagamento/card/${cartaoId}/accept/match`);
    },

    recusarTodasSugestoes: async (cartaoId: number): Promise<void> => {
        await api.patch(`FolhaPagamento/card/${cartaoId}/refuse/match`);
    }
};

export default FolhaPagamentoService;
